
<p-panel>
    <div class="container-fluid gap-5">
        <header>
            <h4>Tarea Fertilizantes 
        
                <div *ngIf="loadingData" style="
                    display: inline-block;
                    margin-right: 10px;
                    position: relative;
                    top: 3px;">
                    <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="6" animationDuration="1.5s">
                    </p-progressSpinner>
                </div>
            </h4>
        </header>
        <div class="row">
            <div class="col-md-12">
                <app-form-builder app-form-builder
                        [fields]="form.formFieldsSectorLeft"
                        [distributionOrder]="this.appName === 'pyf' ? [6] : this.appName === 'donjardin' ? [] : distributionOrder"
                        [distributionColumns]="4"
                        (formChanges)="formChanges($event)"
                        (selectAllcheck)="selectAll()"
                        (mouseleave)="formChanges('')"
                        [model]="model">
                </app-form-builder>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12" [ngClass]="{'col-md': showFertilizantesNPK, 'col-md-12': !showFertilizantesNPK }">
                <h4>Productos abonado</h4>
            
                <app-form-builder [fields]="form.formFieldsBottomLeft"
                    [distributionColumns]="showTareasFertiGramos ? (appName === 'pyf'? 4: 3 ): 2"
                    (formChanges)="formChanges($event)" [model]="model">
                </app-form-builder>
            
            </div>

            <div class="col d-flex flex-column gap-5">
                <div *ngIf="showFertilizantesNPK" class="mx-4 rounded px-0">
            
                    <h4>
                        N / P / K
                        <span *ngIf="showFertilizantesCa">/ Ca</span>
                        <span *ngIf="showFertilizantesS">/ S</span>
                        <span *ngIf="showFertilizantesMg">/ Mg</span>
                        Abonado
                    </h4>
            
                    <table class="table-style center-content mr-2" style="margin-top:20px;">
                        <tr style="background-color:silver">
                            <td style="width: 80px;">N</td>
                            <td style="width: 80px;">P</td>
                            <td style="width: 80px;">K</td>
                            <td *ngIf="showFertilizantesCa" style="width: 80px;">Ca</td>
                            <td *ngIf="showFertilizantesS" style="width: 80px;">S</td>
                            <td *ngIf="showFertilizantesMg" style="width: 80px;">Mg</td>
                        </tr>
                        <tr>
                            <td>{{decimalFormat(totalN, 2) || '0,00'}}</td>
                            <td>{{decimalFormat(totalP, 2) || '0,00'}}</td>
                            <td>{{decimalFormat(totalK, 2) || '0,00'}}</td>
                            <td *ngIf="showFertilizantesCa">
                                {{decimalFormat(totalCa, 2) || '0,00'}}
                            </td>
                            <td *ngIf="showFertilizantesS">
                                {{decimalFormat(totalS, 2) || '0,00'}}
                            </td>
                            <td *ngIf="showFertilizantesMg">
                                {{decimalFormat(totalMg, 2) || '0,00'}}
                            </td>
                        </tr>
                    </table>
                </div>
            
                <div class="mx-4 rounded px-0">
                    @if(appName==='torrepacheco') {
                    <h4> Uds Fertilizantes (Ha/Campaña) </h4>
                    }
            
                    @else {
                    <h4> Unidades fertilizantes </h4>
                    }
            
                    <table *ngIf="form?.sectores?.selected 
                                            && !udsByParcela" class="table-style center-content mr-2">
            
                        <!-- Nombre de Columnas de la Tabla -->
                        <tr style="background-color:silver">
                            <td style="width: 100px;">{{sectorName}}</td>
                            <td style="width: 100px;">Superficie&nbsp;{{textoSuperficie}}</td>
                            <td style="width: 80px;">N</td>
                            <td style="width: 80px;">P</td>
                            <td style="width: 80px;">K</td>
                            <td *ngIf="showFertilizantesCa" style="width: 80px;">Ca</td>
                            <td *ngIf="showFertilizantesS" style="width: 80px;">S</td>
                            <td *ngIf="showFertilizantesMg" style="width: 80px;">Mg</td>
                        </tr>
            
                        <!-- Valores de las Columnas  -->
                        <ng-container *ngFor="
                                        let sector of 
                                        (form?.sectores?.selected || []); 
                                        let i = index">
            
                            <tr *ngIf="udFertN[i]">
                                <td>{{sector?.nombre}}</td>
                                <td>{{decimalFormat(superfSect[i], 2) || '0,00'}}</td>
                                <td>{{decimalFormat(udFertN[i], 2) || '0,00'}}</td>
                                <td>{{decimalFormat(udFertP[i], 2) || '0,00'}}</td>
                                <td>{{decimalFormat(udFertK[i], 2) || '0,00'}}</td>
                                <td *ngIf="showFertilizantesCa">{{decimalFormat(udFertCa[i], 2) || '0,00'}}</td>
                                <td *ngIf="showFertilizantesS">{{decimalFormat(udFertS[i], 2) || '0,00'}}</td>
                                <td *ngIf="showFertilizantesMg">{{decimalFormat(udFertMg[i], 2) || '0,00'}}</td>
                            </tr>
            
                            <tr *ngIf="!udFertN[i]">
                                <td>{{sector?.nombre}}</td>
                                <td>Sector sin superficie</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td *ngIf="showFertilizantesCa">-</td>
                                <td *ngIf="showFertilizantesS">-</td>
                                <td *ngIf="showFertilizantesMg">-</td>
                            </tr>
                        </ng-container>
            
                        <tr *ngIf=" 
                                            ((form?.sectores?.selected || []).length > 1 
                                            && appName !== 'pyf')">
                            <td>Total</td>
                            <td>{{decimalFormat(totalesTabla.superficie, 2) || '0,00'}}</td>
                            <td>{{decimalFormat(totalesTabla.n, 2) || '0,00'}}</td>
                            <td>{{decimalFormat(totalesTabla.p, 2) || '0,00'}}</td>
                            <td>{{decimalFormat(totalesTabla.k, 2) || '0,00'}}</td>
                            <td *ngIf="showFertilizantesCa">
                                {{decimalFormat(totalesTabla.ca, 2) || '0,00'}}
                            </td>
                            <td *ngIf="showFertilizantesS">
                                {{decimalFormat(totalesTabla.s, 2) || '0,00'}}
                            </td>
                            <td *ngIf="showFertilizantesMg">
                                {{decimalFormat(totalesTabla.mg, 2) || '0,00'}}
                            </td>
                        </tr>
            
                    </table>
            
                    <!-- Si unidad/parcela... -->
                    <table *ngIf="
                                form?.parcelas?.selected 
                                && udsByParcela" class="table-style center-content mr-2">
            
                        <!-- Nombre de Columnas de la Tabla -->
                        <tr style="background-color:silver">
                            <td style="width: 100px;">Parcela</td>
                            <td style="width: 100px;">Superficie&nbsp;{{textoSuperficie}}</td>
                            <td style="width: 80px;">N</td>
                            <td style="width: 80px;">P</td>
                            <td style="width: 80px;">K</td>
                            <td *ngIf="showFertilizantesCa" style="width: 80px;">Ca</td>
                            <td *ngIf="showFertilizantesS" style="width: 80px;">S</td>
                            <td *ngIf="showFertilizantesMg" style="width: 80px;">Mg</td>
                        </tr>
            
                        <!-- Valores de las Columnas  -->
                        <ng-container *ngFor="
                                    let parcela of 
                                    (form?.parcelas?.selected || []); 
                                    let i = index">
            
                            <tr *ngIf="udFertN[i]">
                                <td>{{parcela?.nombre}}</td>
                                <td>{{parcela?.superficie_cultivada
                                    || '0,00'}}
                                </td>
                                <td>{{decimalFormat(udFertN[i], 2)
                                    || '0,00'}}
                                </td>
                                <td>{{decimalFormat(udFertP[i], 2)
                                    || '0,00'}}
                                </td>
                                <td>{{decimalFormat(udFertK[i], 2)
                                    || '0,00'}}
                                </td>
                                <td *ngIf="showFertilizantesCa">
                                    {{decimalFormat(udFertCa[i], 2)
                                    || '0,00'}}</td>
                                <td *ngIf="showFertilizantesS">
                                    {{decimalFormat(udFertS[i], 2)
                                    || '0,00'}}
                                </td>
                                <td *ngIf="showFertilizantesMg">
                                    {{decimalFormat(udFertMg[i], 2)
                                    || '0,00'}}
                                </td>
                            </tr>
            
                            <tr *ngIf="!udFertN[i]">
                                <td>{{parcela?.nombre}}</td>
                                <td>Sector sin superficie</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td *ngIf="showFertilizantesCa">-</td>
                                <td *ngIf="showFertilizantesS">-</td>
                                <td *ngIf="showFertilizantesMg">-</td>
                            </tr>
                        </ng-container>
                    </table>
            
                </div>
            </div>
        </div>
        @if (applicationType === 'cropgest') {
            <div class="row mt-5">
                <div class="col">
                    <h4>Tipo de Abonado</h4>
                    
                    <app-form-builder
                            [fields]="form.formFieldsAbonado"
                            [distributionColumns]="6"
                            (formChanges)="formChanges($event)"
                            (selectAllcheck)="selectAll()"
                            [model]="model">
                    </app-form-builder>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col">
                    <h4>Datos PAC</h4>

                    <app-form-builder 
                        [fields]="form.formFieldsPac" 
                        [distributionOrder]="distributionOrderPac" 
                        [distributionColumns]="4"
                        (formChanges)="formChanges($event)" 
                        (selectAllcheck)="selectAll()" 
                        [model]="model">
                    </app-form-builder>
                </div>
                <p *ngIf="errorMessage" style="margin-left: 20px; color: red">{{errorMessage}}</p>
            </div>
        }

        @if (this.showTareasMto) {
            <div class="row">
                <div class="col">
                    <app-form-builder 
                        [model]="model" 
                        (formChanges)="formChanges($event);" 
                        [distributionColumns]="1"
                        [fields]="form.formFieldsOrdenTrabajo">
                    </app-form-builder>
                </div>
                <div class="col">
                    <div class="tareas-camara">
                        <app-upload-images
                        class="mt-4"
                        [model]="model"
                        folder="fertilizantes"
                        tipo="form"
                        (sendImageName)="updateImageModel($event)"
                        ></app-upload-images>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <app-form-builder
                        [model]="model"
                        (formChanges)="formChanges($event)"
                        [distributionColumns]="1" 
                        [fields]="form.formFieldsObs">
                    </app-form-builder>
                </div>
                <div class="col">
                    <div class="tareas-camara">
                        <app-upload-images 
                        [model]="model" 
                        folder="fertilizantes"
                        nombre_imagen = 'image_after' 
                        tipo="form" 
                        (sendImageName)="updateAfterImageModel($event)"
                        ></app-upload-images>
                    </div>
                </div>
            </div>

        }
        @if (model.signature_img) {
            <div class="row mt-5">
                <div class="col">
                    <h5>Firma</h5>

                    @if(this.model.signature_img?.includes('base64')) {
                        <img [src]="this.model.signature_img" class="info-firma-img" alt="Firma">
                    }

                    @else { 
                        <img [src]="serverUrl + 'images/fertilizantes/' + this.model.signature_img" 
                        class="info-firma-img" alt="Firma">
                    }
                </div>

                <div class="col">
                    <app-signature 
                        (sendFile)="getSignature($event)" 
                        (sendTempImg)="updateFirma($event);">
                    </app-signature>
                </div>
            </div>
        } @else if (!model.signature_img) {
            <div class="row mt-5">
                <div class="col">
                    <h5>Firma</h5>

                    <app-signature 
                        (sendFile)="getSignature($event)" 
                        (sendTempImg)="updateFirma($event);">
                    </app-signature>
                </div>
            </div>
        }
    </div>

    <hr>

    <div class="d-flex justify-content-center">
        <!-- Volver -->
        <div>
            <button 
                class="btn btn-dark mx-2" 
                (click)="goBack()">
                Volver
            </button>
        </div>

        <!-- Enviar -->
        <app-request-button
                (click)="submit()"
                [warning]="errorMessage"
                [mode]="requestButtonType"
                [lockOnSuccess]="true"
                [request]="request">
        </app-request-button>
    </div>
</p-panel>